import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError, money } from "../../lib/api";

const Kpi = ({ label, value, testId }) => <div className="admin-stat" data-testid={testId}><strong>{value}</strong><span>{label}</span></div>;

export const OverviewAdmin = () => {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setA(r.data)).catch((e) => toast.error(formatError(e))); }, []);
  if (!a) return <div className="loading">Loading analytics…</div>;
  const maxRev = Math.max(1, ...a.daily.map((d) => d.revenue));
  const maxFunnel = Math.max(1, a.funnel[0]?.count || 1);
  return (
    <div>
      <div className="section-title"><h2>Revenue & learners</h2><span className={`pill ${a.payments_mode === "RAZORPAY" ? "published" : "draft"}`} data-testid="overview-payments-mode">{a.payments_mode}</span></div>
      <div className="admin-stats insight-stats">
        <Kpi label="Total revenue (incl. GST)" value={money(a.revenue_total)} testId="kpi-revenue-total" />
        <Kpi label="Assessment fees (earlier paid tests)" value={money(a.revenue_assessment)} testId="kpi-revenue-assessment" />
        <Kpi label="Certificate fees" value={money(a.revenue_certificate)} testId="kpi-revenue-certificate" />
        <Kpi label="Refunded" value={money(a.refunded_total)} testId="kpi-refunded" />
        <Kpi label="Paid orders" value={a.paid_orders} testId="kpi-paid-orders" />
        <Kpi label="Pass rate" value={a.pass_rate === null ? "—" : `${a.pass_rate}%`} testId="kpi-pass-rate" />
        <Kpi label="Refunds due (duplicates)" value={a.needs_refund} testId="kpi-needs-refund" />
        <Kpi label="New learners (30 days)" value={a.daily.reduce((n, d) => n + d.signups, 0)} testId="kpi-signups-30d" />
      </div>
      <h3 className="sub-h">Revenue, last 30 days</h3>
      <div className="rev-chart" data-testid="overview-revenue-chart">{a.daily.map((d) => (
        <div key={d.date} title={`${d.date}: ${money(d.revenue)} · ${d.signups} signups`}><span style={{ height: `${(d.revenue / maxRev) * 100}%` }} /></div>))}
      </div>
      <h3 className="sub-h">Learner funnel</h3>
      <div className="funnel" data-testid="overview-funnel">{a.funnel.map((f, i) => (
        <div key={f.stage} className="funnel-row" data-testid={`funnel-${i}`}><span>{f.stage}</span><div><i style={{ width: `${(f.count / maxFunnel) * 100}%` }} /></div><b>{f.count}</b></div>))}
      </div>
    </div>
  );
};
